import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import { useProps, useStore } from '../../utils/mobx.utils';
import './BaseCalendarWeekHeader.scss';
function getDaysOfWeek(formatter) {
    var startOfWeek = moment().startOf('week');
    return Array(7).fill(null).map(function (n, i) {
        var m = startOfWeek.add(Math.min(i, 1), 'day');
        return formatter(m);
    });
}
var BaseCalendarWeekHeader = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get formatter() {
            switch (p.format) {
                case 'singleChar': return function (m) { return m.format('dd')[0]; };
                case 'long': return function (m) { return m.format('dddd'); };
                case 'short':
                default: return function (m) { return m.format('ddd'); };
            }
        },
        get daysOfWeek() {
            return getDaysOfWeek(s.formatter);
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("table", { className: "BaseCalendarWeekHeader" },
            React.createElement("thead", null,
                React.createElement("tr", { className: "BaseCalendarWeekHeaderInner" }, s.daysOfWeek.map(function (d, i) { return React.createElement("th", { className: "BaseCalendarWeekHeaderCell", key: d + i, "data-day-of-week": i },
                    React.createElement("span", null, d)); }))))); } });
};
export default BaseCalendarWeekHeader;
